//计划书
let mockBaseUrl = 'http://rap2api.taobao.org/app/mock/228718'

export default {
  // 计划书列表
  '/proposal/proposal/list': mockBaseUrl + '/proposal/proposal/list',
  '/proposal/proposal/toInsurance': mockBaseUrl + '/proposal/proposal/toInsurance',
  '/proposal/proposal/demo': mockBaseUrl + '/proposal/proposal/demo',
  '/proposal/proposal/info': mockBaseUrl + '/proposal/proposal/info',
  '/proposal/file/getFile': mockBaseUrl + '/proposal/file/getFile',
  '/proposal/proposal/deleteProposal': mockBaseUrl + '/proposal/proposal/deleteProposal',
  '/proposal/proposal/saveOrUpdateProposal': mockBaseUrl + '/proposal/proposal/saveOrUpdateProposal'
}
